import { Badge } from "@/components/ui/badge";
import { useOtpStats } from "../hooks/use-otp-logs";
import { Skeleton } from "@/components/ui/skeleton";

interface OtpSummaryTagsProps {
  startDate?: string;
  endDate?: string;
}

export function OtpSummaryTags({ startDate, endDate }: OtpSummaryTagsProps) {
  const { data: stats, isLoading } = useOtpStats({ startDate, endDate });

  if (isLoading || !stats) {
    return (
      <div className="flex items-center gap-3">
        <Skeleton className="h-8 w-32" />
        <Skeleton className="h-8 w-36" />
      </div>
    );
  }

  const verifiedDelivered = `${stats.verified.toLocaleString()} / ${stats.delivered.toLocaleString()}`;
  const successRate = `${stats.successRate.toFixed(2)}%`;

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Badge variant="outline" className="px-3 py-1.5 text-sm font-medium">
        <span className="text-muted-foreground">Verified / Delivered:</span>{" "}
        <span className="font-semibold">{verifiedDelivered}</span>
      </Badge>
      <Badge
        variant="outline"
        className={`px-3 py-1.5 text-sm font-medium ${
          stats.successRate >= 90
            ? "border-green-500 text-green-700"
            : stats.successRate >= 70
            ? "border-yellow-500 text-yellow-700"
            : "border-red-500 text-red-700"
        }`}
      >
        <span className="text-muted-foreground">Success Rate:</span>{" "}
        <span className="font-semibold">{successRate}</span>
      </Badge>
    </div>
  );
}

